export {
  fetchDossiers,
  fetchRecentDossiers,
  addToDossier,
  removeFromDossier,
  toggleMonitoring,
} from './dossierService';
